import {useHeap} from '@newsela/snitch';
import {connect} from 'react-redux';

import {getUser} from 'static/three-oh/src/modules/selectors/userSelectors';

const HeapTrackingContainer = ({user}) => {
  /**
   * Shaped object of user properties necessary to send to heap
   */
  const heapUser = {
    unique_id: user?.id,
    licenses: user?.licenses,
    classroom_grade_levels: user?.classroom_grade_levels,
    date_joined: user?.date_joined,
    id: user?.id,
    email: user?.email,
    is_demo: user?.is_demo,
    is_staff: user?.is_staff,
    is_authenticated: user?.is_authenticated,
    features: user?.features,
    student: user?.student,
    teacher: user?.teacher,
    district_admin: user?.district_admin,
    principal: user?.principal
  };
  useHeap(heapUser);
  return null;
};

const mapStateToProps = (state) => {
  return {
    user: getUser(state),
  };
};

export default connect(mapStateToProps)(HeapTrackingContainer);
